import React from 'react'
import FeatherIcon from 'feather-icons-react';

export default function AddFilterCriteriaView(props) {
    const { item, updateProductFilters, productFilters } = props
    return (
        <React.Fragment>
            <div className="app-card mb-3 mb-lg-4 add-criteria">
                <div className="product-filter-card">
                    <div className="card-content">
                        <div className="d-flex align-items-center">
                            <div className="card-icon">
                                <span className="icon_">
                                    <FeatherIcon
                                        icon="slash"
                                        size="40"
                                        className="icon me-2" />
                                </span>
                            </div>
                            <div className="card-text">
                                <div className="card-header_">
                                    <span>{item.name}</span>
                                </div>
                                <div className="card-description">
                                    <div>Checkbox to show only products that are in stock.</div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div>
                                <button
                                    type="button"
                                    className="st-btn st-btn-primary st-fw-600 st-btn-xs text-capitalize d-flex align-items-center justify-content-center"
                                    onClick={e => {
                                        item.default = "1"
                                        const index_ = productFilters.findIndex(i => i.name === item.name)
                                        productFilters[index_] = item
                                        updateProductFilters(productFilters)
                                    }}
                                >
                                    <span>Add Filter Criteria</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}